import React from 'react';
import css from './css.module.less';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
  ModalContent,
} from 'src/components/Layouts';
import {
  OriCheckbox,
  ModalFooter,
  OriNumberInput,
  Form,
} from 'src/components/Antd';
import { get, isNumber } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;

const ManualValidation = (props: any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { onCancel, value, areaCode, onChange } = props;

  const [form] = Form.useForm();

  React.useEffect(() => {
    form.setFieldsValue(value);
  }, []);

  return (
    <Form
      form={form}
      onFinishFailed={() => {
        return;
      }}
      onFinish={onChange}>
      <ModalContent style={{ paddingTop: 0 }}>
        <Section style={{ paddingTop: 0 }}>
          <div className={css.areaCode}>{areaCode}</div>
          <ItemWrapper
            title={
              <Item name={'enabled'} valuePropName={'checked'}>
                <OriCheckbox>
                  {getI18n('salesChannelLocalisation.index.enable')}
                </OriCheckbox>
              </Item>
            }
            belowComponentTitle={
              <Item
                className={css.zero}
                shouldUpdate={(p, c) => {
                  const pV = get(p, 'enabled');
                  const cV = get(c, 'enabled');
                  return pV != cV;
                }}>
                {({ getFieldValue }: any) => {
                  const enabled = getFieldValue('enabled');
                  return (
                    <Item name={'includeZero'} valuePropName={'checked'}>
                      <OriCheckbox disabled={!enabled}>
                        {getI18n(
                          'salesChannelLocalisation.index.includeleading0indigitcount',
                        )}
                      </OriCheckbox>
                    </Item>
                  );
                }}
              </Item>
            }>
            <Item
              shouldUpdate={(p, c) => {
                const pV = get(p, 'enabled');
                const cV = get(c, 'enabled');
                return pV != cV;
              }}>
              {({ getFieldValue }: any) => {
                const enabled = getFieldValue('enabled');
                return (
                  //   <div className={css.digitsContainer}>
                  <Item
                    name='digits'
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (enabled) {
                            if (!isNumber(value)) {
                              return Promise.reject(
                                new Error(
                                  getI18n(
                                    'salesChannelLocalisation.index.valueisrequired',
                                  ),
                                ),
                              );
                            }
                            if (value < 1) {
                              return Promise.reject(
                                new Error(
                                  getI18n(
                                    'salesChannelLocalisation.index.valuecannotlessthan1',
                                  ),
                                ),
                              );
                            }
                          }
                        },
                      },
                    ]}>
                    <_Input enabled={enabled} />
                  </Item>
                  // <div className={css.text}>
                  //   digits following region code​
                  // </div>
                  //   </div>
                );
              }}
            </Item>
          </ItemWrapper>
        </Section>
      </ModalContent>
      <ModalFooter
        onCancel={onCancel}
        onOk={() => {
          form.submit();
        }}
      />
    </Form>
  );
};
export default ManualValidation;

const _Input = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, enabled } = props;
  return (
    <div className={css.digitsContainer}>
      <OriNumberInput
        value={value}
        onChange={onChange}
        disabled={!enabled}
        size='large'
        className={css.input}
        wrapperStyle={{ flex: 'unset' }}
      />
      <div className={css.text}>
        {getI18n('salesChannelLocalisation.index.digitsfollowingregioncode')}
      </div>
    </div>
  );
};
